// extracted by mini-css-extract-plugin
export default {"formWrapper":"ListForm_formWrapper__sYGtb","columnFrom":"ListForm_columnFrom__j+3yx","label":"ListForm_label__qWkqA"};